'use client'

import { ButtonLink } from '@repo/shared/components'
import { Icon, Row, Typography } from '@repo/ui/components'
import { useTranslate } from '@repo/shared/hooks'

export const BalanceAllCTA = ({
  origin,
}: {
  origin: 'layout' | 'container'
}) => {
  const { t } = useTranslate()

  return (
    <Row
      className={`${origin === 'layout' ? 'sticky top-0' : ''}  justify-between h-fit gap-md p-xs bg-neutral-surface-light`}
    >
      <ButtonLink
        variant='transparent'
        color='neutral'
        size='md'
        href='/wallet'
        aria-label='Back to Wallet'
        startIcon={<Icon name='ArrowRightLine' size='md' className='mt-xs' />}
      />
      <Typography size='md' weight='bold' className='flex-1'>
        {t('walletPage_all_history')}
      </Typography>
    </Row>
  )
}
